import { render, staticRenderFns } from "./ProductClickRegions.vue?vue&type=template&id=3f2c2a4b&"
import script from "./ProductClickRegions.vue?vue&type=script&lang=js&"
export * from "./ProductClickRegions.vue?vue&type=script&lang=js&"
import style0 from "./ProductClickRegions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports